import customAxios from "../../customAxios";
import { APPROVE_COMPANY } from "../../routes";

const ApproveCompany = async (userId: string) => {
  console.log(userId);
  try {
    return (await customAxios.post(APPROVE_COMPANY + "/" + userId)).data;
  } catch (error: unknown) {
    console.error(error);
    return false;
  }
};

export default ApproveCompany;
